<template>
    <div>
        <div class="row">
            <div class="col-md-12 mb-3">
                <div class="float-right">
                    <div class="btn-group shadow-sm">
                        <button class="btn btn-sm btn-default border-0" v-for="interval in periods"
                                :key="interval.value" :class="{'bg-primary text-white': interval.active}"
                                @click="changeInterval(interval)">{{ interval.value | capitalize }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-md-4">
                <overall-score-widget class="h-100 mb-0" type="nps"/>
            </div>
            <div class="col-md-8">
                <trending-over-time-interval type="nps" :max-overall="100" :trendingOverTimeInterval="trendingOverTime"
                                             :loading="trendingOverTimeLoading" class="h-100"/>
            </div>
        </div>
        <card class="card-default">
            <card-header>Your Net Promoter Score Reviews</card-header>
            <card-body class="pt-0">
                <div class="form-inline form-row"><select class="form-control ml-2 select-filter" v-model="sortBy"
                                                          @change="fetchReviews">
                    <option value="review_date|desc">Newest First</option>
                    <option value="review_date|asc">Oldest First</option>
                    <option value="rating|desc">Highest Rating</option>
                    <option value="rating|asc">Lowest Rating</option>
                </select></div>
                <grid
                        :loading="loading" style="min-height: 200px;">
                    <grid-row v-for="review of reviews.data" :key="review.id">
                        <review :review="review" :type="type(review)" :tags="tags"
                                @updated="fetchReviews(page, false)"/>
                    </grid-row>
                    <pagination class="mt-3" :meta="reviews.meta" :links="reviews.links" @page="gotoPage"/>
                </grid>
            </card-body>
        </card>
    </div>
</template>

<script>
    import Review from './ReviewListItem';
    import {mapState} from 'vuex';

    export default {
        components: {Review},
        data() {
            return {
                periods                : [
                    {value: 'daily', active: false},
                    {value: 'weekly', active: false},
                    {value: 'monthly', active: true},
                    {value: 'all time', active: false},
                ],
                periodSelected         : 'monthly',
                trendingOverTime       : [],
                trendingOverTimeLoading: true,
                loading                : false,
                page                   : 1,
                tags                   : [],
                reviews                : {
                    data : [],
                    meta : null,
                    links: null,
                },
                sortBy                 : 'review_date|desc'
            }
        },

        async created() {
            this.trendingOverTimeLoading = true;
            await this.$http.all([
                this.fetchTrendingOverTimeData(),
            ])
                .then(this.$http.spread((trendingOverTime) => {
                    this.trendingOverTime = trendingOverTime.data;
                }))
                .then(() => this.trendingOverTimeLoading = false);
            this.fetchReviews();
            this.fetchTags();
        },

        computed: {
            ...mapState({filter: state => state.filter})
        },

        watch: {
            filter() {
                this.fetchAll(this.periodSelected);
            },
        },

        methods: {
            fetchTags() {
                return this.$http.get(this.$laroute.route('api.tags.index')).then(({data}) => this.tags = data.data);
            },

            fetchTrendingOverTimeData(value = 'monthly') {
                const params = {...this.filter, type: 'nps', interval: value};
                return this.$http
                    .get(this.$laroute.route('api.reviews.trending-over-time'), {params});
            },

            async fetchReviews(page = 1, loading = true) {
                this.loading = loading;
                const params = {
                    ...this.filter,
                    page,
                    sortBy: this.sortBy,
                    type  : 'nps',
                };
                const {data} = await this.$http.get(this.$laroute.route('api.generic-reviews.index'), {params});
                this.loading = false;
                this.reviews = data;
            },

            gotoPage(page) {
                this.fetchReviews(page)
            },

            type(review) {
                return review.campaign ? review.campaign.type : 'public';
            },

            changeInterval(interval) {
                if (interval.active) {
                    return;
                }
                this.periodSelected = interval.value;

                const toggleValue            = true;
                this.trendingOverTimeLoading = true;
                this.disableActiveClass();
                interval.active = toggleValue;

                this.fetchAll(interval.value);
            },

            disableActiveClass() {
                for (let index in this.periods) {
                    if (this.periods.hasOwnProperty(index)) {
                        this.$set(this.periods[index], 'active', undefined);
                    }
                }
            },

            fetchAll(interval) {
                return Promise.all([
                    this.fetchTrendingOverTimeData(interval),
                ]).then(res => {
                    this.trendingOverTime = res[0].data;
                }).then(() => this.trendingOverTimeLoading = false)
            }
        }
    }
</script>
